// src/pages/pcmodule/PcmoduleLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import SidebarLayout from "../../components/common/layout/SidebarLayout";
import { projectMenus } from "../../components/layout/ProjectMenus";
// import Forbidden from "../../components/common/Forbidden";

export default function PcmoduleLayout({ hasPermission }) {
  // if (!hasPermission) return <Forbidden />;

  const { title, base, sections } = projectMenus.pcmodule;

  return (
    <SidebarLayout title={title} base={base} sections={sections}>
      <Outlet />
    </SidebarLayout>
  );
}
